<div class="items-container">
    <div class="logo" routerLink="/home"></div>
    <div class="nav-items">
        <ng-container *ngFor="let item of navItems">
            @if(!item.children){
            <div class="nav-item" [class.highlight]="item.highlight" [routerLink]="item.nav" [routerLinkActive]="'active'">
                <span>@if(item.highlight){<span class="ping" aria-hidden="true"></span>}{{item.title}}</span>
            </div>
            }
            <app-auto-open-menu *ngIf="item.children">
                <div class="nav-item" trigger [routerLinkActive]="'active'" [routerLink]="item.nav">
                    <span>{{item.title}}</span>
                    <mat-icon aria-hidden="true" fontIcon="keyboard_arrow_down"></mat-icon>
                </div>
                <div content>
                    <div>
                        <ng-content *ngFor="let child of item.children">
                            @if(child.nav){
                            <a class="reset-styles" [routerLink]="[child.nav]">
                                <div class="menu-item">
                                    {{child.title}}
                                </div>
                            </a>
                            }
                            <div class="menu-item" (click)="goTo(child.goTo)" *ngIf="child.goTo">
                                {{child.title}}
                            </div>
                        </ng-content>
                    </div>
                </div>
            </app-auto-open-menu>
        </ng-container>
    </div>
    <div class="actions"><app-button [style]="'flat'" [color]="'accent'" [arrow]="true" (click)="goToContactForm()">
            Let's Talk
        </app-button>
    </div>
    <button mat-icon-button class="menu" (click)="openSideMenu.emit()">
        <mat-icon>menu</mat-icon>
    </button>
</div>